import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ImageCarouselComponent } from '@shared/components/image-carousel/image-carousel.component';
import { ImageCarouselService } from '@shared/components/image-carousel/image-carousel.service';

@NgModule({
  declarations: [ImageCarouselComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, A11yModule],
  providers: [ImageCarouselService],
  exports: [ImageCarouselComponent],
})
export class ImageCarouselModule {}
